import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxIntlTelInputPureModule } from 'ngx-intl-tel-input-pure';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { MostUsedModule } from '@shared/components/most-used/most-used.module';
import { SharedPipesModule } from '@shared/pipes/shared-pipes/shared-pipes.module';
import { TtComponent } from './tt/tt.component';


@NgModule({
  declarations: [
    PhoneInputComponent,
    TtComponent,
  ],
  exports: [
    PhoneInputComponent,
    TtComponent
  ],
  imports: [
    CommonModule,
    NgxIntlTelInputPureModule,
    ReactiveFormsModule,
    MostUsedModule,
    SharedPipesModule
  ]
})
export class PhoneInputModule { }
